module.exports = __webpack_public_path__ + "img/icon_5_54.0ae241af.png";